export default __webpack_public_path__ + "assets/img/sendToInterview.17db1ea318dd6e855a6e802cba531e1b.png";